import React, { useState, useEffect } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { API } from "@/App";
import { useLanguage } from "@/LanguageContext";

const GalleryPage = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/gallery`)
      .then((res) => setImages(res.data.map(img => ({
        ...img,
        url: `${API}${img.image_url}`
      }))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen" style={{ background: '#f4e7d8' }}>
      <Navbar />

      <div className="py-16 mandala-pattern" style={{ background: 'linear-gradient(135deg, #721111 0%, #2d1810 100%)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="indian-divider mb-4">
            <span className="text-sm uppercase tracking-widest" style={{ color: '#d4af37' }}>{t("gallery_tag")}</span>
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-4xl sm:text-5xl font-serif-display font-semibold italic mb-4" style={{ color: '#d4af37' }} data-testid="gallery-page-title">
            {t("gallery_title")}
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} style={{ color: '#f5e6d3' }}>
            {t("gallery_subtitle")}
          </motion.p>
        </div>
      </div>

      <div className="h-2" style={{ background: 'linear-gradient(90deg, #721111, #d4af37, #721111)' }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {loading ? (
          <div className="text-center py-20">
            <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-r-transparent" style={{ borderColor: '#721111', borderRightColor: 'transparent' }}></div>
            <p className="mt-4" style={{ color: '#4a3728' }}>{t("loading")}</p>
          </div>
        ) : images.length === 0 ? (
          <div className="text-center py-20">
            <p className="text-lg" style={{ color: '#4a3728' }}>{t("gallery_loading")}</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="gallery-grid">
            {images.map((image, index) => (
              <motion.div
                key={image.id || index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                className="group relative overflow-hidden rounded-xl cursor-pointer dish-card"
                style={{ border: '3px solid #8b4513' }}
                onClick={() => setSelectedImage(image)}
                data-testid={`gallery-image-${index}`}
              >
                <div className="aspect-square overflow-hidden" style={{ background: '#ede1c8' }}>
                  <img src={image.url} alt="Gallery" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" loading="lazy" />
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>

      {selectedImage && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(45, 24, 16, 0.95)' }} onClick={() => setSelectedImage(null)} data-testid="gallery-lightbox">
          <div className="max-w-5xl w-full">
            <img src={selectedImage.url} alt="Gallery" className="w-full h-auto rounded-lg" style={{ border: '4px solid #d4af37' }} />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;
